import React from "react";
import Hero from "../components/Hero";
import Features from "../components/Features";
import ServerInfo from "../components/ServerInfo";
import News from "../components/News";
import Rankings from "../components/Rankings";
import VoteSection from "../components/VoteSection";
import Roadmap from "../components/Roadmap";
import FaqSection from "../components/FaqSection";
import DownloadSection from "../components/DownloadSection";
import { useContentObject } from "../hooks/useContentData";
import { contentFallback } from "../contentDefaults";

const Home = () => {
  const { data: sections } = useContentObject("home.sections", contentFallback("home.sections"));
  const show = (key) => sections?.[key] !== false;

  return (
    <main>
      <Hero />
      {show("features") && <Features />}
      {show("server_info") !== false && <ServerInfo />}
      {show("news") && <News />}
      <Rankings />
      {show("votes") && <VoteSection />}
      {show("roadmap") && <Roadmap />}
      {show("faq") && <FaqSection />}
      <DownloadSection />
    </main>
  );
};

export default Home;
